import axios from 'axios';
import i18n from '@/assets/lang/index';
import { decrypt, encrypt, getCookie, getCredential, getKey, isObject, localesLang } from "@/utils";
import { useI18n } from 'vue-i18n';
import { showToast } from "vant";
import { channelMethods, postToApp } from "@/utils/channelMethod";

let enMessages = i18n.global.messages.value.en;
let errorObject = enMessages['error'];
let errCode = Object.keys(errorObject);
const service = axios.create({
  baseURL: process.env.BASE_API, // api 的 base_url
  timeout: 60000, // request timeout
  responseType: 'json',
});

let pending: Array<any> = [];
let cancelToken = axios.CancelToken;
let removePending = (config: any) => {
  for (let p in pending) {
    let paramsData: any;
    if (
      config.method == 'post' &&
      config.headers['Content-Type'] != 'multipart/form-data'
    ) {
      paramsData = { ...config.data };
      delete paramsData._t;
    } else if (config.method == 'get') {
      paramsData = { ...config.params };
      delete paramsData._t;
    }
    if (
      pending[p].u ===
      config.url + '&' + JSON.stringify(paramsData) + '&' + config.method
    ) {
      pending[p].f('CancelToken');
      pending.splice(Number(p), 1);
      break;
    }
  }
};
let reqNum = 0;
let reqNumChange = () => {
  reqNum--;
  if (reqNum <= 0) {
    pending = [];
    reqNum = 0;
  }
};

function startLoading() {}

function endLoading() {}

function getQueryVariable(variable: string) {
  let pathname = window.location.href;
  let str = pathname.split('?');
  let query = str[1];
  if (!query) return false;
  let vars = query.split('&');
  for (let i = 0; i < vars.length; i++) {
    if (vars[i]) {
      let pair = vars[i].split('=');
      if (pair[0] == variable) {
        return pair[1];
      }
    }
  }
  return false;
}

service.interceptors.request.use(
  config => {
    startLoading();
    config.headers['auth-token'] = getCookie();
    config.headers['identity-proof'] = getCredential();
    config.headers.initial = '';
    config.headers.setContentType('text/plain');

    removePending(config);
    let paramsData: any;
    if (
      config.method == 'post' &&
      config.headers['Content-Type'] != 'multipart/form-data'
    ) {
      paramsData = { ...config.data };
      console.log('request', config.data);
      config.data = encrypt(config.data);
    } else if (config.method == 'get') {
      paramsData = { ...config.params };
      config.params = {
        _t: Date.now(),
        ...config.params
      };
    }
    config.cancelToken = new cancelToken(c => {
      pending.push({
        u: config.url + '&' + JSON.stringify(paramsData) + '&' + config.method,
        f: c
      });
    });
    reqNum++;
    return config;
  },
  error => {
    console.log(error);
    return Promise.reject(error);
  }
);


service.interceptors.response.use(
  res => {
    endLoading();
    reqNumChange();
    let url = res.config.url;
    if (url && url.includes('resource')) {
      return res;
    }

    let result = JSON.parse(decrypt(res.data));
    result.code = String(result.code);
    result.message = String(result.message);
    console.log('result', result);

    res.data = isObject(res.data)
      ? res.data
      : { code: '0', data: res.data };
    //success
    if (['1', '0'].includes(result.code)) {

      return result.data ?? {};
    }

    let _errCode = result.code;
    let reject = {
      ...res.data,
      errMsg: result.message || _errCode
    };

    let langErrMsg = errCode.filter(key => key === result.code)[0];
    if (langErrMsg) {
      const { t } = useI18n({
        inheritLocale: true
      });
      let localeMessages: any = t('error');
      _errCode = localeMessages[langErrMsg];
    } else {
      _errCode = result.message;
    }

    // toast error message
    if (!['-2'].includes(String(result.code))) {
      showToast(_errCode);
    }

    // token invalid
    if (['-2'].includes(String(result.code))) {
      postToApp(channelMethods.login);
    }

    // token invalid
    if (['-5'].includes(String(result.code))) {
      postToApp(channelMethods.auth);
    }
    return Promise.reject(reject);
  },
  error => {
    // Error
    endLoading();
    reqNumChange();
    console.log('error', error);
    let message = i18n.global.t('error.common_network_error');
    return Promise.reject(error);
  }
);

export default service;
